import Vue from 'vue'
import Router from 'vue-router'
const Home = () => import('@/pages/Home')
const Privacy = () => import('@/pages/Privacy')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: Home
    },
    {
      path: '/privacy',
      name: '隐私协议',
      component: Privacy
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  // mode: 'history'  
  mode: 'hash'  //使用#访问
})



// WEBPACK FOOTER //
// ./src/router/index.js